export default __webpack_public_path__ + "static/media/j.776fddfc.svg";